/* GG · Home · Category Rail — sync active dot + counter with scroll,
   and let dots scroll the track. IntersectionObserver on cards. */
(function () {
  'use strict';

  function initOne(rail) {
    var track = rail.querySelector('[data-gg-rail-track]');
    var items = Array.prototype.slice.call(rail.querySelectorAll('[data-gg-rail-item]'));
    var dots = Array.prototype.slice.call(rail.querySelectorAll('[data-gg-rail-dot]'));
    var current = rail.querySelector('[data-gg-rail-current]');
    if (!track || items.length < 2) return;

    /* -1, damit der erste sync() das DOM auch dann anfasst, wenn der
       Browser beim Reload eine Scrollposition wiederhergestellt hat. */
    var active = -1;

    function setActive(i) {
      if (i === active) return;
      active = i;
      dots.forEach(function (d, di) {
        d.classList.toggle('is-active', di === i);
        d.setAttribute('aria-current', di === i ? 'true' : 'false');
      });
      if (current) current.textContent = String(i + 1);
    }

    /* Aktiven Index aus der Scrollposition ableiten — NICHT aus der
       Reihenfolge der IntersectionObserver-Eintraege. Der Observer liefert
       seine erste Runde als einen Batch mit allen beobachteten Elementen,
       und ein forEach darueber laesst schlicht den LETZTEN sichtbaren
       gewinnen. Sobald mehr als eine Karte zu >=60% im Track steht — auf
       dem Desktop praktisch immer, dort sind alle Karten gleichzeitig
       sichtbar — sprang der Zaehler beim Laden deshalb auf die hoechste
       sichtbare Nummer statt auf die erste. Zusaetzlich haengt der Zeitpunkt
       dieser ersten Runde am Layout- und Sichtbarkeitszustand (im Hintergrund
       geladene Tabs bekommen sie gebuendelt erst beim Anzeigen), weshalb der
       Fehler mal auftrat und mal nicht. Ueber die Scrollposition ist das
       Ergebnis eindeutig und beim Laden zwangslaeufig 0. */
    function aktuellerIndex() {
      var scrollbar = track.scrollWidth - track.clientWidth;
      /* Am rechten Anschlag erreicht die letzte Karte den linken Rand nicht
         mehr; die Naechster-Rand-Suche bliebe sonst eine Karte zurueck. */
      if (scrollbar > 2 && track.scrollLeft >= scrollbar - 2) return items.length - 1;
      var links = track.getBoundingClientRect().left;
      var best = 0, bestAbstand = Infinity;
      items.forEach(function (el, i) {
        var abstand = Math.abs(el.getBoundingClientRect().left - links);
        if (abstand < bestAbstand - 0.5) { bestAbstand = abstand; best = i; }
      });
      return best;
    }

    var rafId = null;
    function sync() { rafId = null; setActive(aktuellerIndex()); }
    function anfordern() { if (rafId === null) rafId = requestAnimationFrame(sync); }

    track.addEventListener('scroll', anfordern, { passive: true });
    window.addEventListener('resize', anfordern);
    sync();

    // Dot click → scroll to card.
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var target = items[i];
        if (!target) return;
        track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        setActive(i);
      });
    });
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('[data-gg-rail]')).forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
